export default __webpack_public_path__ + "static/media/tomeofepithur.c694349f.png";